import React from 'react'
import { Zap, Shield, Home, ArrowRight, Timer, Lock, EyeOff } from 'lucide-react';

const ProductSpotlight = () => {

    return (
        <React.Fragment>
            <section className="py-24 bg-black text-white relative overflow-hidden">
                <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ backgroundImage: 'radial-gradient(#10b981 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>

                <div className="max-w-7xl mx-auto px-6 relative z-10">
                    <div className="mb-16">
                        <h2 className="serif-heading text-3xl font-bold text-codegreen mb-2">Product Spotlight</h2>
                    </div>

                    <div className="grid lg:grid-cols-2 gap-16 items-start">
                        {/* GhostFlow Section */}
                        <div>
                            <h2 className="serif-heading text-4xl md:text-5xl font-bold mb-6">Stop Renting Your Infrastructure.</h2>
                            <p className="text-xl text-slate-300 mb-10">
                                Introducing <a href="/ghost-flow/" className="text-codegreen font-bold">GhostFlow</a>—Automated Content Publishing, Done Right.
                            </p>

                            <div className="space-y-8 mb-12">
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <Zap className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Blazing Fast</p>
                                        <p className="text-slate-400">Static Site Generation via Gatsby & Netlify.</p>
                                    </div>
                                </div>
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <Shield className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Secure By Default</p>
                                        <p className="text-slate-400">No public database exposed to the web.</p>
                                    </div>
                                </div>
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <Home className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Absolute Ownership</p>
                                        <p className="text-slate-400">You own the machine. No monthly "SaaS Tax".</p>
                                    </div>
                                </div>
                            </div>

                            <a href="/contact-us">
                                <button className="bg-codegreen text-navy-950 px-8 py-4 rounded font-bold text-3xl hover:bg-codegreen-dark hover:transition-all flex items-center group shadow-xl">
                                    Get a GhostFlow Quote
                                    <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </button>
                            </a>
                        </div>

                        {/* PiHole Utils Section */}
                        <div>
                            <h2 className="serif-heading text-4xl md:text-5xl font-bold mb-6">Reclaim Your Digital Focus.</h2>
                            <p className="text-xl text-slate-300 mb-10">
                                Introducing <a href="/pihole-utils/" className="text-codegreen font-bold">PiHole Utils</a>—Self-Discipline & Telemetry Companion.
                            </p>

                            <div className="space-y-8 mb-12">
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <Timer className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Smart Focus Timers</p>
                                        <p className="text-slate-400">Stackable auto-re-enable countdowns on focus bypasses.</p>
                                    </div>
                                </div>
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <Lock className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Focus Cooldown Lock</p>
                                        <p className="text-slate-400">Self-discipline locks that prevent compulsive bypasses.</p>
                                    </div>
                                </div>
                                <div className="flex gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center text-codegreen">
                                        <EyeOff className="w-12 h-12" />
                                    </div>
                                    <div>
                                        <p className="m-0 text-3xl font-bold">Smart Noise Filtering</p>
                                        <p className="text-slate-400">Exclude background IoT and OS telemetry with one click.</p>
                                    </div>
                                </div>
                            </div>

                            <a href="/contact-us">
                                <button className="bg-codegreen text-navy-950 px-8 py-4 rounded font-bold text-3xl hover:bg-codegreen-dark hover:transition-all flex items-center group shadow-xl">
                                    Get PiHole Utils
                                    <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

ProductSpotlight.propTypes = {
}

export default ProductSpotlight


